import React from "react";
import "./Gallery.css";

type Tile = {
  title: string;
  subtitle: string;
  tone: "violet" | "pink" | "mint";
};

const tiles: Tile[] = [
  { title: "утро дома", subtitle: "рутина без спешки", tone: "violet" },
  { title: "мама & малыш", subtitle: "тепло и безопасность", tone: "pink" },
  { title: "самозабота", subtitle: "маленькие ритуалы", tone: "mint" },
  { title: "покупки", subtitle: "обзоры и честность", tone: "violet" },
  { title: "reels идеи", subtitle: "хуки + монтаж", tone: "pink" },
  { title: "уют", subtitle: "детали интерьера", tone: "mint" }
];

export function Gallery() {
  return (
    <div className="gallery">
      {tiles.map((t, idx) => (
        <div key={idx} className={`tile tile-${t.tone}`}>
          <div className="tileTop">
            <div className="tileTitle">{t.title}</div>
            <div className="tileDot" aria-hidden="true" />
          </div>
          <div className="tileSubtitle">{t.subtitle}</div>
          <div className="tileMedia" aria-hidden="true">
            <div className="tileMediaInner" />
          </div>
        </div>
      ))}
    </div>
  );
}